export default {
    Photos: "Photos",
    TAKE_PHOTO_DESCRIPTION: "To take a photo, click on the camera icon, to cancel, click on the X.",
    SelectDocumentType: "Select Document Type",
    SelectDocumentFace: "Select Document Face",
  
    ErrorSendingPhoto: "Error Sending Photo",
    PhotoSentSuccessfully: "Photo Sent Successfully",
    
    AreYouSureToDelete: "Are you sure you want to delete?",
    YouWontBeAbleToRevertThis: "You won't be able to revert this!",
    Yes: "Yes",
    Cancel: "Cancel",
}